import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const EditConfiguredCodeModal = ({
  isOpen,
  onClose,
  title,
  description,
  currentCode,
  onSave,
  inputId = 'configured-code-term-input',
  emptyCodeMessage = 'No SNOMED code configured.',
}) => {
  const [editableTerm, setEditableTerm] = useState('');

  useEffect(() => {
    if (isOpen) {
      setEditableTerm(currentCode?.terms?.[0] ?? '');
    }
  }, [isOpen, currentCode]);

  if (!isOpen) return null;

  const handleSave = () => {
    if (!currentCode) return;
    const trimmed = editableTerm.trim();
    onSave({
      ...currentCode,
      terms: trimmed ? [trimmed] : [],
    });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container modal-animated">
        <div className="modal-header">
          <h2>{title}</h2>
          <button type="button" className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-content">
          {description && (
            <p className="retention-description" style={{ marginBottom: '12px' }}>
              {description}
            </p>
          )}
          {currentCode ? (
            <>
              <div className="current-code" style={{ marginBottom: '16px' }}>
                {String(currentCode.code).startsWith('CUSTOM') ? (
                  <span className="code-id" style={{ fontStyle: 'italic', color: '#6c757d' }}>Custom entry</span>
                ) : (
                  <span className="code-id">({currentCode.code})</span>
                )}
              </div>
              <label className="configured-code-term-label" htmlFor={inputId}>
                Label
              </label>
              <input
                id={inputId}
                type="text"
                className="configured-code-term-input"
                value={editableTerm}
                onChange={(e) => setEditableTerm(e.target.value)}
                placeholder="Enter preferred term"
                autoFocus
              />
            </>
          ) : (
            <p className="retention-description">{emptyCodeMessage}</p>
          )}
        </div>
        <div className="modal-actions">
          <button type="button" className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="admin-submit-button"
            onClick={handleSave}
            disabled={!currentCode}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditConfiguredCodeModal;
